export default ":host ::ng-deep ngb-tabset > .nav-tabs {\n  display: none;\n}"